import { render, staticRenderFns } from "./CustomImagePopup.vue?vue&type=template&id=06d25f4c&scoped=true&"
import script from "./CustomImagePopup.vue?vue&type=script&lang=ts&"
export * from "./CustomImagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./CustomImagePopup.vue?vue&type=style&index=0&id=06d25f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d25f4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VFileInput,VIcon,VRow})
